module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading == true) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : (_vm.loading == false && _vm.list.length) ? _c('el-table', {
    ref: "tableData",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "default-sort": {
        prop: 'balance',
        order: 'descending'
      }
    },
    on: {
      "row-click": _vm.rowClicked
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-row', {
          attrs: {
            "gutter": 10
          }
        }, [(props.row.volume) ? _c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 12,
            "lg": 3,
            "xl": 3
          }
        }, [_c('div', {
          staticClass: "grid-content"
        }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.translation + ".volume"))) + ": ")]), _vm._v(" " + _vm._s(props.row.volume))])])]) : _vm._e(), _vm._v(" "), (props.row.abv) ? _c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 12,
            "lg": 3,
            "xl": 3
          }
        }, [_c('div', {
          staticClass: "grid-content"
        }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.translation + ".abv"))) + ": ")]), _vm._v(" " + _vm._s(props.row.abv))])])]) : _vm._e(), _vm._v(" "), (props.row.amountLiter) ? _c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 12,
            "lg": 3,
            "xl": 3
          }
        }, [_c('div', {
          staticClass: "grid-content"
        }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.translation + ".liter"))) + ": ")]), _vm._v(" " + _vm._s(props.row.amountLiter))])])]) : _vm._e(), _vm._v(" "), (props.row.exciseGroup) ? _c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 12,
            "lg": 3,
            "xl": 3
          }
        }, [_c('div', {
          staticClass: "grid-content"
        }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.translation + ".exciseGroup"))) + ": ")]), _vm._v(" " + _vm._s(props.row.exciseGroup))])])]) : _vm._e(), _vm._v(" "), (props.row.exciseBasic) ? _c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 12,
            "lg": 3,
            "xl": 3
          }
        }, [_c('div', {
          staticClass: "grid-content"
        }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.translation + ".exciseBasic"))) + ": ")]), _vm._v(" " + _vm._s(props.row.exciseBasic))])])]) : _vm._e(), _vm._v(" "), (props.row.excisePackaging) ? _c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 12,
            "lg": 3,
            "xl": 3
          }
        }, [_c('div', {
          staticClass: "grid-content"
        }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.translation + ".excisePackaging"))) + ": ")]), _vm._v(" " + _vm._s(props.row.excisePackaging))])])]) : _vm._e(), _vm._v(" "), (props.row.exciseAdditionalCode) ? _c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 12,
            "lg": 3,
            "xl": 3
          }
        }, [_c('div', {
          staticClass: "grid-content"
        }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t((_vm.translation + ".exciseAdditionalCode"))) + ": ")]), _vm._v(" " + _vm._s(props.row.exciseAdditionalCode))])])]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t((_vm.translation + ".flag")),
      "sortable": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [(scope.row['flag'] == false) ? _c('i', {
          staticClass: "el-icon-success success"
        }) : _c('i', {
          staticClass: "el-icon-warning status_ cancelled"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t((_vm.translation + ".createdAt")),
      "sortable": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row['createdAt']))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t((_vm.translation + ".exciseType")),
      "sortable": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_c('a', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.link(scope.row)
            }
          }
        }, [_vm._v("\n          " + _vm._s(scope.row['excisableType']) + "\n        ")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t((_vm.translation + ".receiverName")),
      "sortable": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row['receiverName']))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t((_vm.translation + ".productName")),
      "sortable": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row['productName']))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t((_vm.translation + ".qty")),
      "sortable": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row['qty']))])]
      }
    }])
  })], 1) : _c('el-alert', {
    attrs: {
      "title": this.noDataMessage || _vm.$t('table.noData'),
      "type": "warning"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ede2113","hasScoped":false}!./src/app/components/exciseTable/exciseTable.html
// module id = 3057
// module chunks = 1